import { createDecorator } from '../../instantiation/common/instantiation.js';
const IMenuService = ( createDecorator('menuService'));
export { IMenuService };
